module.exports = __webpack_public_path__ + "static/media/logo.c61a7c8e.png";